export interface ClientPoint {
  x: number;
  y: number;
}

const READER_ROTATION_SELECTOR = '[data-reader-rotation="90"]';

export function isInsideRotatedReader(element: Element): boolean {
  return element.closest(READER_ROTATION_SELECTOR) !== null;
}

/**
 * 将浏览器 client 坐标映射到元素旋转前的逻辑坐标。
 * 阅读壳顺时针旋转 90° 后，逻辑 X 对应屏幕 Y，逻辑 Y 对应反向屏幕 X。
 */
export function clientPointToElement(
  element: HTMLElement,
  clientX: number,
  clientY: number,
  targetWidth: number,
  targetHeight: number
): ClientPoint {
  const rect = element.getBoundingClientRect();
  if (rect.width <= 0 || rect.height <= 0 || targetWidth <= 0 || targetHeight <= 0) {
    return { x: 0, y: 0 };
  }

  if (isInsideRotatedReader(element)) {
    return {
      x: ((clientY - rect.top) * targetWidth) / rect.height,
      y: ((rect.right - clientX) * targetHeight) / rect.width
    };
  }

  return {
    x: ((clientX - rect.left) * targetWidth) / rect.width,
    y: ((clientY - rect.top) * targetHeight) / rect.height
  };
}
